import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
} from "@mui/material";
import {
  ContactMail,
  Bathtub,
  SquareFoot,
  Apartment,
  Euro,
} from "@mui/icons-material";
import { Box, useMediaQuery } from "@mui/system";

const RealEstateCard = ({
  titolo,
  camere,
  indirizzo,
  balcone,
  prezzo,
  dettagli,
  grandezza,
  bagni,
  piano,
  ascensore,
  contratto,
  photos,
  terrazzo,
}) => {
  const navigate = useNavigate();
  // Chiama l'hook per ottenere i dati della proprietà
  const handleNavigation = () => {
    navigate(`/property/${titolo}`);
  };
  const isMobile = useMediaQuery("(max-width: 1024px)");

  return (
    <Card
      sx={{
        position: "relative",
        width: isMobile ? "100%" : "95%",
        maxWidth: "600px",
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <CardMedia
        sx={{ objectFit: "cover", width: "100%", height: "200px" }}
        component="img"
        image={photos[0]}
        alt={titolo}
      />
      <Typography
        variant="h6"
        color="primary"
        mt={1}
        sx={{
          borderRadius: "8px",
          fontFamily: "degular",
          p: "5px 20px",
          color: "white",
          backgroundColor:
            contratto === "vendesi" || "vendita" ? "#437B65CC" : "#7B4040CC",
          position: "absolute",
          top: "3px",
          right: "3px",
          textTransform: "uppercase",
          mr: 2,
        }}
        display="flex"
        alignItems="center"
      >
        {contratto}
      </Typography>
      <CardContent>
        <Typography
          sx={{
            minHeight: "70px",
          }}
          variant="h6"
          component="div"
          fontWeight="bold"
        >
          {titolo}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {indirizzo}
        </Typography>
        <Typography
          variant="h6"
          color="primary"
          mt={1}
          display="flex"
          alignItems="center"
          gap={0.5}
        >
          <Euro fontSize="small" /> {prezzo}
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          mt={1}
          display="flex"
          gap={2}
          flexWrap="wrap"
          alignItems="center"
        >
          <Box display="flex" alignItems="center" gap={0.5}>
            <Apartment fontSize="small" /> {camere} locali
          </Box>
          <Box display="flex" alignItems="center" gap={0.5}>
            <SquareFoot fontSize="small" /> {grandezza} m²
          </Box>
          <Box display="flex" alignItems="center" gap={0.5}>
            <Bathtub fontSize="small" /> {bagni} bagno
          </Box>
          <Box display="flex" alignItems="center" gap={0.5}>
            <Apartment fontSize="small" /> Piano {piano}
          </Box>
        </Typography>
        <Box
          height={"40px"}
          sx={{
            overflowY: "auto",
          }}
          alignItems={"center"}
          display="flex"
          flexWrap="wrap"
          gap={1}
          mt={2}
        >
          {terrazzo ? (
            <Typography
              variant="body1"
              color="text.primary"
              fontWeight="medium"
              sx={{
                backgroundColor: "#f0f0f0",
                borderRadius: "8px",
                padding: "2px 10px",
                display: "inline-block",
              }}
            >
              Terrazzo
            </Typography>
          ) : null}
          {ascensore ? (
            <Typography
              variant="body1"
              color="text.primary"
              fontWeight="medium"
              sx={{
                backgroundColor: "#f0f0f0",
                borderRadius: "8px",
                padding: "2px 10px",
                display: "inline-block",
              }}
            >
              Ascensore
            </Typography>
          ) : null}
          {balcone ? (
            <Typography
              variant="body1"
              color="text.primary"
              fontWeight="medium"
              sx={{
                backgroundColor: "#f0f0f0",
                borderRadius: "8px",
                padding: "2px 10px",
                display: "inline-block",
              }}
            >
              Balcone
            </Typography>
          ) : null}
          {(dettagli || "").split(",").map((feature, index) => (
            <Typography
              key={index}
              variant="body1"
              color="text.primary"
              fontWeight="medium"
              sx={{
                backgroundColor: "#f0f0f0",
                borderRadius: "8px",
                padding: "2px 10px",
                display: "inline-block",
              }}
            >
              {feature.trim()}
            </Typography>
          ))}
        </Box>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2, backgroundColor: "#0C6D8D" }}
          startIcon={<ContactMail />}
          onClick={handleNavigation}
        >
          Scopri di più
        </Button>
      </CardContent>
    </Card>
  );
};

export default RealEstateCard;
